function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 20.9004,
  cy: 21.223,
  r: 20.75,
  fill: "#5BC0CE"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M30.705 21.2224C30.7052 21.2226 30.7053 21.2228 30.7055 21.223C30.7053 21.2232 30.7052 21.2234 30.705 21.2236C30.5909 21.3937 30.4192 21.6391 30.1929 21.9347C29.7398 22.5266 29.0704 23.3157 28.2071 24.1037C26.4741 25.6855 24.0047 27.223 20.9616 27.223C17.8508 27.223 15.3503 25.6829 13.6048 24.1024C12.7347 23.3146 12.0626 22.5257 11.6084 21.9342C11.3816 21.6387 11.2099 21.3935 11.0958 21.2236C11.0957 21.2234 11.0956 21.2232 11.0954 21.223C11.0956 21.2228 11.0957 21.2227 11.0958 21.2225C11.2099 21.0525 11.3816 20.8073 11.6084 20.5119C12.0626 19.9203 12.7347 19.1315 13.6048 18.3437C15.3503 16.7631 17.8508 15.223 20.9616 15.223C24.0047 15.223 26.4741 16.7605 28.2071 18.3423C29.0704 19.1303 29.7398 19.9195 30.1929 20.5113C30.4192 20.8069 30.5909 21.0523 30.705 21.2224Z",
  stroke: "white"
});

var _ref4 = /*#__PURE__*/React.createElement("circle", {
  cx: 20.9006,
  cy: 21.1418,
  r: 2.91821,
  stroke: "white"
});

var SvgVision = function SvgVision(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgVision, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/vision.f2e9c3da.svg";
export { ForwardRef as ReactComponent };